<template>
<div>
    <!-- modal -->
    <b-modal id="ownerFormModal" ref="ownerFormModal" centered size="xl" no-close-on-backdrop :title=" $t('client.info_owner')" hide-footer @hide="onClientModalHide">
        <reminder-form ref="reminderForm"></reminder-form>
        <client-merge-company-form ref="clientMergeCompanyFormModal"></client-merge-company-form>
        <mail-send-form ref="mailSendFormModal"></mail-send-form>
        <b-card>
            <validation-observer ref="simpleRules">
                <div class="custom-search d-flex justify-content-end">
                    <b-col class="col-lg-4">
                        <b-form>
                            <label for="client-name-input">{{ $t('client.name_owner') }}</label>
                            <b-form-group>
                                <validation-provider #default="{ errors }" :name=" $t('client.name_owner')" rules="required">
                                    <b-form-input size="sm" id="client-name-input" v-model="clientName" maxlength="250" :state="errors.length > 0 ? false:null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-2">
                        <b-form>
                            <label for="owner-code-input">{{ $t('client.owner_code') }}</label>
                            <b-form-group>
                                <cleave style="height: 2em;" id="ownerCode" v-model="ownerCode" class="form-control" :raw="false" :options="ownerCodeOptions" placeholder="000000" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-2">
                        <b-form>
                            <validation-provider :name=" $t('client.sector')" :rules="{ excluded:0}" v-slot="{ errors }">
                                <label for="sector-input">{{ $t('client.sector') }}</label>
                                <b-form-select size="sm" :state="errors.length > 0 ? false:null" v-model="sectorSelect" value-field="id" text-field="nameTR" :options="sectorOption" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4 mt-2" style="text-align: right;">
                        <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="clientConflictCheck">
                            {{$t('others.ok_title')}}
                        </b-button>
                        <b-dropdown style="width: 4em; height: 2em;" id="dropdown-grouped" variant="outline-primary" right class="dropdown-icon-wrapper" size="sm">
                            <template #button-content>
                                <feather-icon icon="PrinterIcon" size="10" class="align-middle" />
                            </template>
                            <b-dropdown-item @click="downloadClientWordFile(wordTemplate.id, wordTemplate.name)" v-for="wordTemplate in wordTemplateList" :key="wordTemplate.id">
                                <span>{{wordTemplate.name}}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                        <b-button variant="outline-primary" class="ml-1" size="sm" v-b-tooltip.html :title="$t('others.reminder')" @click="getReminderInfo()">
                            <feather-icon icon="BellIcon" size="10" class="align-middle" />
                        </b-button>
                        <b-button :hidden="hiddenClientControl" variant="outline-primary" v-b-tooltip.html :title="$t('others.merge_company')" size="sm" class="btn-icon ml-1" @click="mergeCompany(0)">
                            <feather-icon icon="GitMergeIcon" />
                        </b-button>
                        <client-merge-company-form :getClientList="getOwnerList" :clientId="this.id"></client-merge-company-form>
                        <mail-send-form :getClientList="getOwnerList" :clientId="this.id"></mail-send-form>
                    </b-col>
                </div>
            </validation-observer>
        </b-card>

        <!-- <b-card>
                <div class="custom-search d-flex justify-content-end">
                    <b-row>
                        <b-col>

                        </b-col>
                    </b-row>
                </div>
                <validation-observer ref="simpleRules">
                    <b-row>
                        <b-col class="col-md-2 mt-2">
                            <b-form>
                                <label for="owner-code-input">{{ $t('client.owner_code') }}</label>
                                <b-form-group>
                                    <cleave style="height: 2em;" id="ownerCode" v-model="ownerCode" class="form-control" :raw="false" :options="ownerCodeOptions" placeholder="000000" />
                                </b-form-group>
                            </b-form>
                        </b-col>
                        <b-col class="col-md-2 mt-2">
                            <b-form>
                                <validation-provider :name=" $t('client.sector')" :rules="{ excluded:0}" v-slot="{ errors }">
                                    <label for="sector-input">{{ $t('client.sector') }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false:null" v-model="sectorSelect" value-field="id" text-field="nameTR" :options="sectorOption" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form>
                        </b-col>
                    </b-row>    
                </validation-observer>
            </b-card> -->
        <b-card :hidden="hiddenClientControl">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                        <b-tab :title=" $t('client.address')" active style="width:100%;">
                            <b-card-text>
                                <client-address-list ref="clientAddressList" :clientId="this.id"></client-address-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title=" $t('client.digital_archive')" style="width:100%;">
                            <b-card-text>
                                <documents-list :recordId="this.id" :moduleId="1"></documents-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title=" $t('client.notes')" style="width:100%;">
                            <b-card-text>
                                <client-note-list :clientId="this.id"></client-note-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title=" $t('client.conflict')" style="width:100%;">
                            <b-card-text>
                                <client-conflict-list :clientId="this.id"></client-conflict-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title=" $t('client.folders')" style="width:100%;">
                            <b-card-text>
                                <client-folder-list :clientOwnershipInfo="clientOwnershipInfo" :ownerControl="true" :agentControl="false" :clientId="this.id" :getClientList="getOwnerList"></client-folder-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getOwnerList: {
            type: Function
        }
    },
    data() {
        return {
            id: 0,
            clientName: '',
            sectorSelect: 0,
            sectorOption: [],
            ownerCode: null,
            hiddenClientControl: true,
            collapseType: 'margin',
            ownerCodeOptions: {
                blocks: [6],
                numericOnly: true
            },
            wordTemplateList: [],
            mailTemplateList: [],
            selected: null,
            working: false,
            annuity: false,
            compensationFee: false,
            patentCertificate: false,
            clientOwnershipInfo: {},
            clientAccountingInformation: {},
            forceClose: false
        }
    },
    methods: {
        async onClientModalHide(evt) {
            if (this.forceClose) {
                this.forceClose = false
                return
            }
            const addressCount = this.$refs.clientAddressList.rows;
            if (this.id > 0 && addressCount.length == 0) {
                evt.preventDefault();
                this.$PrivateConfirm(this.$t("others.client_auth_address_title"), this.$t("others.client_auth_address_message"), "warning", this.$t("others.client_auth_confirm_button"), this.$t("others.client_auth_cancel_button"))
                    .then(result => {
                        if (result.value) {
                            this.forceClose = true
                            this.$bvModal.hide('ownerFormModal')
                        }
                    });
            }
        },
        async mergeCompany() {
            this.$refs.clientMergeCompanyFormModal.showInfo(0)
        },
        //async getInfoMail() {
        //    this.$refs.mailSendFormModal.showInfo(0)
        //},
        async getReminderInfo() {
            this.$refs.reminderForm.showInfo(0, this.id, 1)
        },
        showInfo(id) {
            this.$refs['ownerFormModal'].show()
            this.id = id

            if (this.id == 0) {
                this.hiddenClientControl = true
            } else {
                this.hiddenClientControl = false
            }

            const data = {
                id: this.id
            }
            const controller = {
                name: 'Client'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.clientId = response.data.client.id
                    this.wordTemplateList = response.data.wordTemplateList
                    this.mailTemplateList = response.data.mailTemplateList
                    this.clientName = response.data.client.name
                    this.sectorSelect = response.data.client.sectorId
                    this.sectorOption = response.data.sectorList
                    this.ownerCode = response.data.client.ownerCode
                    this.clientOwnershipInfo = response.data.clientOwnershipInformation
                    this.clientAccountingInformation = response.data.clientAccountingInformation
                    this.sectorOption.splice(0, 0, this.$nullSelected('nameTR'))
                } else {
                    this.$bvModal.hide('ownerFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        downloadClientWordFile(documentId, name) {
            const data = {
                moduleId: 1,
                documentId: documentId,
                clientId: this.id
            }
            const controller = {
                name: 'Client',
                actionName: 'DownloadClientWordFile'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile(name + '-' + this.clientName, response.data.base64, 'docx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        clientConflictCheck() {
            if (this.id > 0) {
                this.addOrUpdate()
            } else {
                this.$refs.simpleRules.validate().then(success => {
                    if (success) {
                        const data = {
                            string: this.clientName
                        }
                        const controller = {
                            name: 'ClientConflict',
                            actionName: 'GetClientConflictListByClientName'
                        }
                        const payload = {
                            data: data,
                            controller: controller
                        }
                        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                            if (response.data.clientConflictList.length > 0) {
                                // Müvekkil Çıkar Çatışması için kontrol içine mesaj basılması gerekiyor bunu nasıl yapacağımızı konuşmalıyız . 
                                this.$ClientConflictControl(response.data.resultMessage).then(result => {
                                    if (result.value) {
                                        this.addOrUpdate()
                                    }
                                })
                            } else {
                                this.addOrUpdate()
                            }
                        })
                    }
                })
            }

        },
        prepareClientMail(mailTemplateId) {
            const data = {
                mailTemplateId: mailTemplateId,
                clientId: this.id
            }
            const controller = {
                name: 'Client',
                actionName: 'PrepareClientMail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$refs.mailSendFormModal.showInfo(response.data)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        addOrUpdate() {
            const data = {
                id: this.id,
                name: this.clientName,
                isAgent: false,
                isOwner: true,
                ownerCode: this.ownerCode,
                sectorId: this.sectorSelect
            }
            const controller = {
                name: 'Client'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            if (this.getOwnerList != null) {
                                this.getOwnerList()
                            }
                            this.$SaveAlert()

                            if (this.id == 0) {
                                this.id = response.data.clientId
                                this.hiddenClientControl = false
                            }
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        },
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

[dir] .dark-layout .modal .modal-content,
[dir] .dark-layout .modal .modal-body,
[dir] .dark-layout .modal .modal-footer {
    background-color: #272e3f !important;
    border-color: #3b4253;
}

[dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}
</style>
